import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePermission } from '../../../hooks/usePermission';
import VyTooltip, { Placement } from '../../common/VyTooltip';

interface InlineEditButtonInterface {
  isEditMode: boolean;
  setIsEditMode: (value: boolean) => void;
  tooltip: string;
  forceShow: boolean;
  className?: string;
  tooltipPlacement?: Placement;
  stopPropagation?: boolean;
}
const InlineEditButton = ({
  isEditMode,
  tooltip,
  setIsEditMode,
  forceShow = false,
  className,
  tooltipPlacement = 'left',
  stopPropagation,
}: InlineEditButtonInterface) => {
  const { isEventHost } = usePermission();

  if (!isEventHost && !forceShow) return null;

  return (
    <div className={className ?? 'absolute top-2 right-2 z-40'} onClick={(e) => stopPropagation && e.stopPropagation()}>
      <VyTooltip title={tooltip} placement={tooltipPlacement}>
        <button className="z-40 grid w-10 h-10 text-black bg-white bg-opacity-75 rounded-full place-items-center" onClick={() => setIsEditMode(!isEditMode)}>
          <FontAwesomeIcon icon={isEditMode ? faTimes : faEdit} size="lg" />
        </button>
      </VyTooltip>
    </div>
  );
};
export default InlineEditButton;
